import Vue from 'vue';
import Router from 'vue-router';

import store from './store';

import NotFound from './views/NotFound.vue';
const Error500 = () => Promise.resolve(import('./views/Error500.vue'));
const Error502 = () => Promise.resolve(import('./views/Error502.vue'));
const Error503 = () => Promise.resolve(import('./views/Error503.vue'));
import Login from './views/Login.vue';
import Home from './views/Home.vue';
import Products from './views/Products.vue';
import Points from './views/Points.vue';
import Reports from './views/Reports.vue';
import ReportPoints from './views/ReportPoints.vue';
import TicketPrint from './views/TicketPrint.vue';
import Unilabs from './views/Unilabs.vue';
import Payment from './views/Payment.vue';
import TicketView from './views/TicketView.vue';
import Settings from './views/Settings.vue';
import SettingsPersonal from './views/SettingsPersonal.vue';
import SettingsProcessor from './views/SettingsProcessor.vue';
import ContactUs from './views/ContactUs.vue';
import CashlessPoints from './views/CashlessPoints.vue';
import CashlessRecharge from './views/CashlessRecharge.vue';

Vue.use(Router);
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
  routes: [
    // Machupicchu Setting User
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
      children: [
        {
          path: 'personal',
          name: 'Personal',
          component: SettingsPersonal,
          meta: {
            auth: true,
          },
        },
        {
          path: 'processor/:idProcessor',
          name: 'Processor',
          component: SettingsProcessor,
          meta: {
            auth: true,
          },
        },
      ],
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        auth: true,
      },
    },
    {
      path: '/productos/:eventId?',
      name: 'Products',
      component: Products,
      meta: {
        auth: true,
      },
    },
    {
      path: '/puntos/:eventId',
      name: 'Points',
      component: Points,
      meta: {
        auth: true,
      },
    },
    {
      path: '/cashless/:eventId',
      name: 'CashlessPoints',
      component: CashlessPoints,
      meta: {
        auth: true,
      },
    },
    {
      path: '/cashless-recharge/:eventId',
      name: 'CashlessRecharge',
      component: CashlessRecharge,
      meta: {
        auth: true,
      },
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter(to, from, next) {
        if (store.state.auth.token) {
          router.push({ name: 'Home' });
        }
        next();
      },
    },
    {
      path: '/logout',
      name: 'Logout',
      beforeEnter() {
        store.dispatch('logout');
        store.commit('cleanCartProducts');
        router.push({ name: 'Login' });
      },
    },
    {
      path: '/reportes/:eventId?',
      name: 'Reports',
      component: Reports,
      meta: {
        auth: true,
      },
    },
    {
      path: '/reporte-puntos/:eventId',
      name: 'ReportPoints',
      component: ReportPoints,
      meta: {
        auth: true,
      },
    },
    {
      path: '/print/:tId',
      name: 'TicketPrint',
      component: TicketPrint,
      meta: {
        auth: true,
      },
    },
    {
      path: '/ticket/:tId',
      name: 'Ticket',
      component: TicketView,
      meta: {
        auth: true,
      },
    },
    {
      path: '/unilabs/:eventId',
      name: 'Unilabs',
      component: Unilabs,
      meta: {
        auth: true,
      },
    },
    {
      path: '/payment/:ticketId',
      name: 'Payment',
      component: Payment,
      props: true,
      meta: {
        auth: true,
      },
    },
    {
      path: '/contact-us',
      name: 'ContactUs',
      component: ContactUs,
      props: true,
      meta: {
        auth: true,
      },
    },
    {
      path: '/500',
      name: 'Error500',
      component: Error500,
    },
    {
      path: '/502',
      name: 'Error502',
      component: Error502,
    },
    {
      path: '/503',
      name: 'Error503',
      component: Error503,
    },
    {
      path: '*',
      name: 'Error404',
      component: NotFound,
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (
    process.env.VUE_APP_ENV === 'ppr' &&
    store.state.auth.token &&
    to.name !== 'Construction' &&
    to.name !== 'Logout'
  ) {
    next({ name: 'Login' });
  } else if (to.matched.some((record) => record.meta.auth)) {
    if (store.state.auth.token) {
      if (to.meta.authAccess && !store.state.authAccess.includes(to.meta.authAccess)) {
        router.push({ name: 'Home' });
      } else if (to.meta.authNotAccess && store.state.authAccess.includes(to.meta.authNotAccess)) {
        router.push({ name: 'Home' });
      } else if (!store.state.auth.roles.some((r) => r.name === 'agency') && to.meta.authAccess) {
        router.push({ name: 'Home' });
      } else {
        next();
      }
    } else {
      router.push({
        name: 'Login',
        query: {
          redirect: to.fullPath,
        },
      });
    }
  } else {
    next();
  }
});

export default router;
